var map = {
	"./": 3753,
	"./ads/adobe.svg": 8164,
	"./ads/canva.svg": 6788,
	"./ads/dropbox.svg": 1203,
	"./ads/fastgamesapi.svg": 5630,
	"./ads/genius-feeds-logo.svg": 6644,
	"./ads/genius-logo.svg": 3772,
	"./ads/geniuscom.svg": 6739,
	"./ads/github.svg": 3802,
	"./ads/gitlab.svg": 7522,
	"./ads/google.svg": 7078,
	"./ads/grammarly.svg": 2515,
	"./ads/mailchimp.svg": 4423,
	"./ads/monetria.svg": 2248,
	"./ads/notion.svg": 3280,
	"./ads/pixup-logo.svg": 2347,
	"./ads/spotify.svg": 5123,
	"./ads/whatsapp.svg": 2841,
	"./baseball-frame.avif": 9476,
	"./baseball.svg": 1662,
	"./basketball-frame.avif": 6903,
	"./basketball.svg": 3383,
	"./carousel-frame.svg": 9584,
	"./chalkboard.avif": 5809,
	"./court-active.svg": 4558,
	"./court.svg": 7903,
	"./detailed-statistics.avif": 1648,
	"./dots-bg.svg": 5294,
	"./feature-detailed-stats.svg": 5643,
	"./feature-field-vision.svg": 7456,
	"./feature-live-tracking.svg": 9311,
	"./football-frame.avif": 1193,
	"./football.svg": 3825,
	"./foul.svg": 9592,
	"./futuristic-football-player.avif": 1688,
	"./genius-tracker-logo.svg": 5910,
	"./heat-map.avif": 3745,
	"./hero-pixup.avif": 7737,
	"./hero.avif": 1120,
	"./icehockey-frame.avif": 9418,
	"./icehockey.svg": 1708,
	"./index": 3753,
	"./index.tsx": 3753,
	"./kits/soccer-jersey-0.svg": 6157,
	"./kits/soccer-jersey-1.svg": 7612,
	"./kits/soccer-jersey-10.svg": 3860,
	"./kits/soccer-jersey-2.svg": 9935,
	"./kits/soccer-jersey-3.svg": 3534,
	"./kits/soccer-jersey-4.svg": 913,
	"./kits/soccer-jersey-5.svg": 9792,
	"./kits/soccer-jersey-6.svg": 9187,
	"./kits/soccer-jersey-7.svg": 2226,
	"./kits/soccer-jersey-8.svg": 133,
	"./kits/soccer-jersey-9.svg": 2148,
	"./live-match-tracking.avif": 5616,
	"./logo-simple.svg": 5278,
	"./pass-map.avif": 9118,
	"./pixup-football-player.png": 9886,
	"./pixup-logo-simple.svg": 8653,
	"./pixup-logo.svg": 6934,
	"./play.svg": 188,
	"./previews/basketballFlashBannerFooterText.avif": 3187,
	"./previews/basketballFlashBannerPoints.avif": 6692,
	"./previews/basketballFlashBannerTeamName.avif": 4597,
	"./previews/basketballTimer.avif": 4330,
	"./previews/categorySubtypeLabel.avif": 5946,
	"./previews/categorySubtypesActiveClass.avif": 7949,
	"./previews/categorySubtypesActiveClass2.avif": 6485,
	"./previews/categorySubtypesActiveClass3.avif": 5110,
	"./previews/categorySubtypesInactiveClass.avif": 120,
	"./previews/categorySubtypesInactiveClass2.avif": 3146,
	"./previews/categorySubtypesInactiveClass3.avif": 8489,
	"./previews/categoryTabLabel.avif": 8045,
	"./previews/categoryTabLabel2.avif": 9093,
	"./previews/categoryTabLabel3.avif": 9350,
	"./previews/categoryTabsActiveClass.avif": 3084,
	"./previews/categoryTabsActiveClass2.avif": 4278,
	"./previews/categoryTabsActiveClass3.avif": 9109,
	"./previews/categoryTabsInactiveClass.avif": 9941,
	"./previews/categoryTabsInactiveClass2.avif": 2797,
	"./previews/categoryTabsInactiveClass3.avif": 1518,
	"./previews/chartTitle.avif": 4300,
	"./previews/chartValue.avif": 4643,
	"./previews/default-preview.avif": 7222,
	"./previews/favicon.avif": 3058,
	"./previews/heroBackground.avif": 5862,
	"./previews/heroPrimaryText.avif": 6111,
	"./previews/heroRightImage.avif": 6981,
	"./previews/iceHockeyTimer.avif": 3989,
	"./previews/mainLogo.avif": 9288,
	"./previews/pageTitle.avif": 6417,
	"./previews/playerNameBall.avif": 1541,
	"./previews/prematchInfoText.avif": 9195,
	"./previews/prematchKickoffText.avif": 8888,
	"./previews/prematchTeamName.avif": 5810,
	"./previews/prematchVsText.avif": 4164,
	"./previews/scoreboardBaseballCounts.avif": 3276,
	"./previews/scoreboardBaseballInning.avif": 9413,
	"./previews/scoreboardText.avif": 4755,
	"./previews/scoreboardText2.avif": 8843,
	"./previews/scoreboardText3.avif": 1692,
	"./previews/simpleLogo.avif": 9007,
	"./previews/soccerChalkboardPlayerText.avif": 6418,
	"./previews/soccerInfoCardDescription.avif": 6419,
	"./previews/soccerInfoCardTitle.avif": 8755,
	"./previews/soccerTimer.avif": 3230,
	"./previews/sportTabLabel.avif": 4667,
	"./previews/sportTabsButtonActiveColorClass.avif": 8779,
	"./previews/sportTabsButtonHeightClass.avif": 1661,
	"./previews/sportTabsButtonInactiveColorClass.avif": 7736,
	"./previews/statusMessageBigTitle.avif": 9419,
	"./previews/statusMessageTitle.avif": 8967,
	"./previews/statusMessageTitle2.avif": 9607,
	"./previews/tennisSets.avif": 1696,
	"./previews/timelineEventTitle.avif": 6879,
	"./previews/timelineMinutePill.avif": 8954,
	"./previews/timelineTitle.avif": 1593,
	"./previews/volleyballScoreboard.avif": 7868,
	"./previews/volleyballSets.avif": 3047,
	"./shape-black.svg": 3659,
	"./shape-gray.svg": 4247,
	"./shape-primary.svg": 5064,
	"./shape-title.svg": 5488,
	"./shape-white.svg": 9649,
	"./tennis-frame.avif": 8903,
	"./tennis.svg": 9303,
	"./timeout.svg": 5071,
	"./title-frame.svg": 4672,
	"./volleyball-frame.avif": 3516,
	"./volleyball.svg": 310,
	"./xg-map.avif": 5078
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;